export default __webpack_public_path__ + "static/media/laundry.1e9c8511.svg";